import { Html } from "@react-three/drei";
import { HtmlProps } from "@react-three/drei/web/Html";
import { twMerge } from "tailwind-merge";

export function Annotation({
  children,
  className,
  wrapperClassName,
  ...props
}: React.PropsWithChildren<
  {
    wrapperClassName?: string;
    className?: string;
  } & HtmlProps
>) {
  return (
    <Html
      distanceFactor={7}
      className={twMerge("select-none pointer-events-none", wrapperClassName)}
      center
      sprite
      {...props}
    >
      <div className={twMerge("annotation text-sm text-black", className)}>
        {children}
      </div>
    </Html>
  );
}
